import React from 'react';
import { Modal, ModalBody, ModalHeader } from "../modal/Modal";

const DeepDriveReportModal = ({ isOpen, toggle, reportData, isLoading, title }) => {
    console.log('DeepDriveReportModal reportData:', reportData);
    if (reportData) {
        console.log('NarrativeResult:', reportData.NarrativeResult || reportData.narrativeResult);
    }
    return (
        <Modal isOpen={isOpen} toggle={toggle} className="modal-xl deep-drive-report-modal">
            <ModalHeader toggle={toggle}>
                <div className="w-100">
                    <h2 className="modal-title-custom">{title || 'Deep Drive Analysis Report'}</h2>
                </div>
            </ModalHeader>
            <ModalBody>
                {isLoading ? (
                    <div className="text-center p-5">
                        <div className="report-spinner mx-auto"></div>
                        <p>Generating your report...</p>
                    </div>
                ) : reportData ? (
                    <div className="report-content">
                        {(reportData.MediaDetails || reportData.mediaDetails) && (reportData.MediaDetails || reportData.mediaDetails).length > 0 && (
                            <div className="media-details-section mb-4">
                                <h3 className="section-title mb-3">Analyzed Media</h3>
                                <div className="row">
                                    {(reportData.MediaDetails || reportData.mediaDetails).map((media, index) => (
                                        <div className="col-12 mb-4" key={media.Id || media.id || index}>
                                            <div className="media-card card h-100">
                                                <div className="card-body">
                                                    <h5 className="card-title">{media.Title || media.title}</h5>
                                                    <p className="card-text small text-muted">{media.Description || media.description}</p>
                                                    <div className="media-preview-container">
                                                        {(media.MediaUrl || media.mediaUrl) && (
                                                            <div className="media-item">
                                                                <span className="media-label">Reference:</span>
                                                                <img src={media.MediaUrl || media.mediaUrl} alt="Reference" className="img-fluid rounded" />
                                                            </div>
                                                        )}
                                                        {(media.PerformedMediaUrl || media.performedMediaUrl) && (
                                                            <div className="media-item">
                                                                <span className="media-label">Your Video:</span>
                                                                <video src={media.PerformedMediaUrl || media.performedMediaUrl} className="img-fluid rounded" controls />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {!(reportData.NarrativeResult || reportData.narrativeResult) && (
                            <div className="alert alert-info">
                                <p><strong>Debug:</strong> Report object received but no <code>NarrativeResult</code> found.</p>
                                <details>
                                    <summary>View Raw Data</summary>
                                    <pre className="small bg-dark text-white p-2 mt-2">{JSON.stringify(reportData, null, 2)}</pre>
                                </details>
                            </div>
                        )}

                        {(reportData.NarrativeResult || reportData.narrativeResult) && (
                            <div
                                className="narrative-section mb-4 p-3 bg-light rounded shadow-sm"
                                style={{ fontFamily: 'inherit', lineHeight: '1.6', fontSize: '15px' }}
                                dangerouslySetInnerHTML={{ __html: reportData.NarrativeResult || reportData.narrativeResult }}
                            />
                        )}

                        {!(reportData.IsReportCompleted || reportData.isReportCompleted) && (
                            <div className="alert alert-warning mt-3">
                                <i className="fa fa-exclamation-triangle mr-2"></i>
                                This report is still being processed. Some analysis may be missing until all media is uploaded properly.
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="text-center p-5">
                        <p className="h5 text-muted">No report data found.</p>
                        <p className="small text-muted mt-2">The console log "Final Report Data State" contains the actual object received.</p>
                    </div>
                )/* END TERNARY */}
            </ModalBody>
        </Modal>
    );
};

export default DeepDriveReportModal;
